import React, { useEffect } from 'react'
import { useFormik } from 'formik'
import { getUserId } from '../../helpers/auth'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { Button, Input, Modal } from 'antd'
import Loader from '../../pages/pages/loader'
import { useCreateAppStoreMutation, useUpdateAppStoreByIdMutation } from '../../redux/apis/linkManagement/app/stores/lmAppsStoresApiSlice'

const EditCreateAppStore = ({ state, open, setOpen, record }) => {
  const [
    updateService,
    { isLoading: isUpdating, isSuccess: SuccessUpdate, error: errorUpdate }
  ] = useUpdateAppStoreByIdMutation()
  const [
    addService,
    { isLoading: isAdding, isSuccess: SuccessAdd, error: errorAdd }
  ] = useCreateAppStoreMutation()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      app_store_name: record?.app_store_name || '',
      abuse_email: record?.abuse_email || '',
      abuse_form: record?.abuse_form || '',
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      app_store_name: Yup.string().required('Please Enter App Store Name'),
      abuse_email: Yup.string().required('Please Enter Abuse Email'),
    }),

    onSubmit: async values => {
      const formData = new FormData()
      for (let key in values) {
        formData.append(key, values[key])
      }

      try {
        if (state === 'edit') {
          await updateService({
            body: formData,
            id: record?.id
          }).unwrap()
        } else if (state === 'create') {
          await addService(formData).unwrap()
        }
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (errorAdd?.data) {
      const errorMessages = Object.values(errorAdd.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (errorUpdate?.data) {
      const errorMessages = Object.values(errorUpdate.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [errorAdd, errorUpdate])

  useEffect(() => {
    console.log(SuccessAdd, SuccessUpdate)
    if (SuccessAdd && state === 'create') {
      toast.success('App Store created successfully!')
      setOpen(false)
    } else if (SuccessUpdate && state === 'edit') {
      toast.success('App Store updated successfully!')
      setOpen(false)
    }
  }, [state, SuccessAdd, SuccessUpdate])

  return (
    <Modal
      className='customModal'
      open={open}
      title={state === 'edit' ? `Edit App Store` : 'Create App Store'}
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).map(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isAdding || isUpdating} />

      <div className=' mb-3'>
        <label className="form-label">App Store Name</label>
        <Input
          type='text'
          name='app_store_name'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.app_store_name}
        />
        {validation.touched.app_store_name && validation.errors.app_store_name ? (
          <p className='text-danger'>{validation.errors.app_store_name}</p>
        ) : null}
      </div>
      
      <div className=' mb-3'>
        <label className="form-label">Abuse Email</label>
        <Input
          type='text'
          name='abuse_email'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.abuse_email}
        />
        {validation.touched.abuse_email && validation.errors.abuse_email ? (
          <p className='text-danger'>{validation.errors.abuse_email}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <label className="form-label">Abuse form</label>
        <Input
          type='text'
          name='abuse_form'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.abuse_form}
        />
        {validation.touched.abuse_form && validation.errors.abuse_form ? (
          <p className='text-danger'>{validation.errors.abuse_form}</p>
        ) : null}
      </div>
    </Modal>
  )
}

export default EditCreateAppStore
